var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3999 18.5504H17.8001C17.5541 18.5504 17.3501 18.3464 17.3501 18.1004C17.3501 17.8544 17.5541 17.6504 17.8001 17.6504H21.3999C21.6459 17.6504 21.8499 17.8544 21.8499 18.1004C21.8499 18.3464 21.6459 18.5504 21.3999 18.5504Z",
    fill: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3999 20.9507H17.8001C17.5541 20.9507 17.3501 20.7468 17.3501 20.5008C17.3501 20.2548 17.5541 20.0508 17.8001 20.0508H21.3999C21.6459 20.0508 21.8499 20.2548 21.8499 20.5008C21.8499 20.7468 21.6459 20.9507 21.3999 20.9507Z",
    fill: "#B1B1B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9992 13.9119V11.188C21.9992 10.342 21.6152 10 20.6613 10H18.2374C17.2834 10 16.8994 10.342 16.8994 11.188V13.9059C16.8994 14.7578 17.2834 15.0938 18.2374 15.0938H20.6613C21.6152 15.0998 21.9992 14.7578 21.9992 13.9119Z",
    fill: "#B1B1B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0998 13.9119V11.188C15.0998 10.342 14.7158 10 13.7619 10H11.338C10.384 10 10 10.342 10 11.188V13.9059C10 14.7578 10.384 15.0938 11.338 15.0938H13.7619C14.7158 15.0998 15.0998 14.7578 15.0998 13.9119Z",
    fill: "#B1B1B1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0998 20.6623V18.2383C15.0998 17.2844 14.7158 16.9004 13.7619 16.9004H11.338C10.384 16.9004 10 17.2844 10 18.2383V20.6623C10 21.6162 10.384 22.0002 11.338 22.0002H13.7619C14.7158 22.0002 15.0998 21.6162 15.0998 20.6623Z",
    fill: "#B1B1B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderIcon);
export default __webpack_public_path__ + "static/media/Placeholder_Icon.de35f684.svg";
export { ForwardRef as ReactComponent };